
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSwitch, AppAvatarBreadcrumb } from '@/components';
import { useAvatarItemAdd } from '@/modules/avatar/item/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSwitch, AppAvatarBreadcrumb },
    setup() {
        const { model, v$, fetch, create } = useAvatarItemAdd();

        onMounted(() => {
            fetch();
        });

        return { v$, model, create };
    }
});
